import { isMainnet } from '@/constants/index'
import mainnetLookupTables from '@/root/cypress/fixtures/orderbook-lookup-tables.mainnet.json'
import testnetLookupTables from '@/root/cypress/fixtures/orderbook-lookup-tables.testnet.json'
import testnetMarkets from '@/root/cypress/fixtures/orderbook-markets.json'
import mainnetMarkets from '@/root/cypress/fixtures/orderbook-markets.mainnet.json'
import { api } from '@/utils/apis/index'
import { toResultAsync } from '@/utils/helpers'

export type OrderbookMarketMetaData = {
  market_address: string
  base_token_mint_address: string
  quote_token_mint_address: string
}

export const fetchOrderbookMarkets = async (): Promise<OrderbookMarketMetaData[]> => {
  const [, response] = await toResultAsync(api.get('orderbook/markets'))
  const fixedMarkets = isMainnet ? mainnetMarkets : testnetMarkets
  return (response?.data || fixedMarkets.data).filter(Boolean)
}

export const fetchOrderbookLookupTables = async (): Promise<Record<string, string>> => {
  const [, response] = await toResultAsync(api.get('orderbook/lookup-tables'))
  const fixedLookupTables = isMainnet ? mainnetLookupTables : testnetLookupTables
  return (response?.data || fixedLookupTables)
}
